import React,{useState,useEffect, useRef} from 'react'
import authQueries from '../../queries/authQueries';
import { useFormContext } from '../../Context/FormContext';
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PlusOutlined } from '@ant-design/icons';
// import { Modal, Upload } from 'antd';
import { useDropzone } from 'react-dropzone';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import MailCopyCheckbox from '../../common/MailCopyCheckbox';
import { Spin, } from 'antd';


const Step5 = ({setCurrent, current, setCurrentTab, currentTab, navTab, setNavTab}) => {

    const { formData, updateFormData } = useFormContext();
    const [loading, setLoading] = useState(false);

    const [issue, setIssue] = useState("");
    const [cause, setCause] = useState("");
    const [needs, setNeeds] = useState("");
    const [issueCount, setIssueCount] = useState(2000);
    const [count, setCount] = useState(2000);

    const [selectedFile, setSelectedFile] = useState([]);

    const [files, setFiles] = useState([]);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [uploadProgress, setUploadProgress] = useState(0);

    const [showProgress, setShowProgress] = useState(false);

    const [uploadedFiles, setUploadedFiles] = useState([]);

    const fileInputRef = useRef(null)

    

    function fileValidator(file) {
      if (file.size > 1000000) {
        alert("File size is larger than 10 MB")
        return {
          code: "size-too-large",
          message: `File size is larger than 10 MB`
        };
      }
    
      return null
    }

    const { acceptedFiles, fileRejections, getRootProps, getInputProps, isDragAccept, isDragActive, isDragReject } = useDropzone({
      maxFiles: 3,       // Allow up to 5 files
      onDrop: (acceptedFiles, rejectedFiles) => {
      },
      validator:fileValidator 
    });


    const getUploadParams = ({ file }) => {
      const body = new FormData();
      body.append('file', file);
      return { url: '/upload-endpoint', body };
    };

    // const handleChangeStatus = ({ file, meta, xhr }, status) => {

    //   if(status === 'error_file_size'){
    //     alert("File size is larger than 10 MB")
    //     return false
    //   }

    //   if (status === 'done') {
    //     setUploadProgress(100);
       
        
    //     setUploadedFiles((prevFiles) => 
    //       [...prevFiles, { file, previewURL: URL.createObjectURL(file) },]
    //     );
        
    //   }
    //   else if (status === 'uploading') {
    //     const percentage = Math.round((xhr.loaded / xhr.total) * 100);
    //     setUploadProgress(percentage);
    //   }
    

    //   else if(status === 'removed'){
    //     setUploadedFiles((prevFiles) => prevFiles.filter((file) => file !== file));
    //     setUploadedFiles([])
        
    //   }


    // };


    const validationSchema = yup.object({
    
        email: yup
          .string('⚠ Enter your email')
          .email('⚠ Enter a valid email')
          .required('⚠ Email is required'),
        issues: yup
          .string('⚠ Enter What happened')
          .required('⚠ What happened is required'),
    });
        

    const { register, reset, control, handleSubmit, formState: { errors }} = useForm({
      resolver: yupResolver(validationSchema),
    });

    
    const OtpCheck  = authQueries.useOtpCheckMutation(

      (response) => {
        //   navigation.navigate('otp',{otp: response?.user?.token})
      setLoading(false)

      setNavTab(navTab + 1)
      setCurrent(current + 1)
  
      }
      
    );

    const IssueHandler = (e) => {

      const inputText = e.target.value
  
      if(inputText?.length <= issueCount ){
        setIssue(inputText)
      }
  
      updateFormData({ what_happened: e.target.value })
      
    }

    const CauseHandler = (e) => {

      const inputText = e.target.value
  
      if(inputText?.length <= count ){
        setCause(inputText)
      }
  
      updateFormData({ what_caused: e.target.value })
      
    }
  
    const NeedsHandler = (e) => {
  
      const inputText = e.target.value
  
      if(inputText?.length <= count ){
        setNeeds(inputText)
      }
  
      updateFormData({ what_need_tobe_done: e.target.value })
      
    }

    const removeUploadedFile = (index) => {
      setUploadedFiles((prevUploadedFiles) => {
        // Create a copy of the array without the file at the specified index
        const updatedFiles = [...prevUploadedFiles];
        updatedFiles.splice(index, 1);
        return updatedFiles;
      });
    };

    const handleFileClick = () => {
      fileInputRef.current.click()
    }

    const handleFileUpload = async (file, setFiles, setUploadedFiles, setShowProgress) => {
      const formData = new FormData();
      formData.append('file', file);
    
      const xhr = new XMLHttpRequest();
    
      xhr.open('POST', '/upload-endpoint', true);
    
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const loaded = event.loaded;
          const total = event.total;
    
          setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles[newFiles.length - 1].loading = Math.floor((loaded / total) * 100);
            return newFiles;
          });
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          const fileName = file.name;
          const fileSize = file.size < 1024 ? `${file.size} KB` : `${(file.size / (1024 * 1024)).toFixed(2)} MB`;
    
          setUploadedFiles((prevUploadedFiles) => [
            ...prevUploadedFiles,
            { name: fileName, size: fileSize, file },
          ]);
          setFiles([]);
          setShowProgress(false);
        } else {
          // Handle the case where the upload failed, e.g., show an error message.
        }
      };
    
      xhr.send(formData);
    }

    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      console.log(file)
      
       // Validate file type
       const allowedTypes = [
        "image",
        "audio",
        "video",
        "application/pdf",
        "application/vnd.ms-excel",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      
      const fileType = file.type.split("/")[0]; // Get the main type (image, audio, video, application)
      
      const fileExtension = file.name.split(".").pop().toLowerCase(); // Get the file extension

      console.log("File Type:", fileType);
      console.log("File Extension:", fileExtension);

      // if (fileExtension === 'zip' || fileExtension === 'rar' || fileExtension === '7z' || fileExtension === 'iso' || fileExtension === 'gz' || fileExtension === 'tgz' || fileExtension === 'bz2' || fileExtension === 'xz' || fileExtension === 'exe' || fileExtension === 'apk' || fileExtension === 'msi' || fileExtension === 'deb' || fileExtension === 'csv' || fileExtension === 'plist' || fileExtension === 'dll' || fileExtension === 'sys' || fileExtension === 'bin' || fileExtension === 'bat' || fileExtension === 'sh' || fileExtension === 'mdb' || fileExtension === 'accdb'  || fileExtension === 'dmg'  || fileExtension === 'pkg' || fileExtension === 'rpm' || fileExtension === 'ttf' || fileExtension === 'otf' || fileExtension === 'woff' || fileExtension === 'woff2' || fileExtension === 'otf' || fileExtension === 'html' || fileExtension === 'css' || fileExtension === 'js' || fileExtension === 'json' || fileExtension === 'xml') {
      //   alert("Invalid file type. Please upload only images, audio, video files, and documents.");
      //   return false;
      // }

      if (!allowedTypes.find((type) => type === fileType || type === file.type)) {
        alert("Invalid file type. Please upload only images, audio, video files, and documents.");
        return false;
      }

      const fileSize = 10 * 1024 * 1024

      if(file.size > fileSize) {
        alert("Maximum size exceeded")
        return false
      }
      const fileName =
        file.name.length > 12 ? `${file.name.substring(0, 13)}... .${file.name.split('.')[1]}` : file.name;
    
      setFiles((prevState) => [...prevState, { name: fileName, loading: 0 }]);
      setShowProgress(true);
    
      handleFileUpload(file, setFiles, setUploadedFiles, setShowProgress);
    };


    // const handleFileChange = (e) => {
    //   // setSelectedFile(e.target.files[0]);
    //   const file = e.target.files[0]
    //   console.log("FILEEEEEEE", file)
    //   if(!file) return;
    //   const fileName = file.name.length > 12 ? `${file.name.substring(0,13)}... .${file.name.split('.')[1]}` : file.name
    //   setFiles(prevState => [...prevState, {name: fileName, loading:0}])
    //   // setSelectedFile([...selectedFile, e?.target?.files[0]])
    //   setShowProgress(true)

    //   const xhr = new XMLHttpRequest();

    //   xhr.open('POST', '/upload-endpoint', true);

    //   xhr.upload.onprogress = (event) => {
    //     if (event.lengthComputable) {
    //       const loaded = event.loaded;
    //       const total = event.total;
    
    //       setFiles((prevFiles) => {
    //         const newFiles = [...prevFiles];
    //         newFiles[newFiles.length - 1].loading = Math.floor((loaded / total) * 100);
    //         return newFiles;
    //       });
    //     }
    //   };

    //   xhr.onload = () => {
    //     if (xhr.status === 200) {
    //       const fileSize = file.size < 1024 ? `${file.size} KB` : `${(file.size / (1024 * 1024)).toFixed(2)} MB`;
    //       setUploadedFiles([...uploadedFiles, { name: fileName, size: fileSize }]);
    //       setFiles([]);
    //       setShowProgress(false);
    //     }
    //   };

    //   // onUploadProgress: ({loaded, total}) => {
    //   //   setFiles(prevState => {
    //   //     const newFiles = [...prevState]
    //   //     newFiles[newFiles.length - 1].loading = Math.floor((loaded / total) * 100)
    //   //     return newFiles
    //   //   })
    //   //   if(loaded == total){
    //   //     const fileSize = total < 1024 ? `${total} KB` : `${(loaded / (1024*1024)).toFixed(2)} MB`
    //   //     setUploadedFiles([...uploadedFiles, {name: fileName, size: fileSize}])
    //   //     setFiles([])
    //   //     setShowProgress(false)
    //   //   }
    //   // }

    // };


    const FileUpload = authQueries.useCodeUploadMutation(
      (response) => {
        const updatedFormData = {
          ...formData,
          Files: response?.files, 
        };
    
        updateFormData(updatedFormData);
      }
    )
      

    const onSubmit = async(data) =>{

      setLoading(true)

      setIsButtonDisabled(true)

        await updateFormData({ what_happened : data.issues ,email: data.email, mail_issue_copy: "YES"  })
        const datavalues = {
          email: data?.email,
        };

        const fileData = new FormData();

        // selectedFile.forEach(item => {
        //   fileData.append('file', item)
        // })

        uploadedFiles.forEach(item => {
          fileData.append('file', item?.file)
        })

        FileUpload.mutateAsync(fileData)

        OtpCheck.mutateAsync(datavalues);

      
    };
      


  return (

    <div>

      <Spin spinning={loading} size='large'>

        <div className="tab-pane" id="step5" role="tabpanel" aria-labelledby="nav-step5-tab">
                                  
          {/* <div className="main-hding">Enter your Workplace Code provide by your employer</div> */}

          <form onSubmit={handleSubmit(onSubmit)}>
                                
            <div className="row">
                <div className="col">
                    <label className="haveInfo">What Happened?<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>
                    <small>Will be shared with your employer</small>
                    <textarea 
                      style={{minHeight:"150px"}} 
                      maxLength={2000}
                      defaultValue={formData?.what_happened}
                      {...register('issues')} 
                      className="form-control"
                      onChange={(e) => IssueHandler(e)} 
                      >
                    </textarea>
                    <small className="justify-content-end  d-flex smlfnt cnt">{issueCount - issue?.length} / 2000 Characters left</small>
                    {/* <small className="justify-content-end  d-flex smlfnt cnt">2000 Characters</small> */}

                    {

                        errors?.issues &&

                            <div className='err' style={{marginBottom: 10}}>
                                {errors?.issues?.message}
                            </div>

                        }
                </div>
                <div className="col">
                    <label className="haveInfo">What Caused It?</label>
                    <small>Will be shared with your employer</small>

                    <textarea 
                      style={{minHeight:"150px"}} 
                      {...register('cause')}
                      defaultValue={formData?.what_caused}
                      maxLength={2000} 
                      className="form-control"
                      onChange={(e) => CauseHandler(e)} 
                      >
                    </textarea>

                    <small className="justify-content-end  d-flex smlfnt cnt">{count - cause?.length} / 2000 Characters left</small>
                    {/* <small className="justify-content-end  d-flex smlfnt cnt">2000 Characters</small> */}
                </div>
                
                
            </div>
            
            <div className="row">
                
              <div className="col">
                  <label className="haveInfo">What Needs to be Done ?</label>
                  <small>Will be shared with your employer<br/>&nbsp;</small>

                  <textarea 
                    style={{minHeight:"150px"}} 
                    {...register('needs')}
                    defaultValue={formData?.what_need_tobe_done}
                    maxLength={2000} 
                    className="form-control"
                    onChange={(e) => NeedsHandler(e)} 
                    >
                  </textarea>

                  <small className="justify-content-end  d-flex smlfnt cnt">{count - needs?.length} / 2000 Characters left</small>
                  {/* <small className="justify-content-end  d-flex smlfnt cnt">2000 Characters</small> */}
              </div>


              <div className="col">
                <label className="haveInfo">Attachment</label>
                <small><strong style={{color: 'red'}}>10 MB</strong> maximum for each file allowed and maximum 3 files can be uploaded eg. pictures video, audio or document.</small>
                <small>Will be shared with your employer</small>
                  
                  {/* <form  className="dropzone" id="myId"></form> */}

                {/* <input 
                  type="file"
                  className="form-control"
                  onChange={handleFileChange} 
                />

                <br />

                <input 
                  type="file"
                  className="form-control"
                  onChange={handleFileChange} 
                />

                <br />

                <input 
                  type="file"
                  className="form-control"
                  onChange={handleFileChange} 
                /> */}

                <div className='upload-box'>
                You can Upload Maximum 3 files
                  <div className='layout'  style={{height: uploadedFiles.length === 3 ? 50 : 170, cursor: uploadedFiles.length === 3 ? 'not-allowed' : 'pointer'  }} onClick={handleFileClick}>

                    <input 
                      type="file"
                      className="file-input"
                      name='file'
                      hidden
                      disabled={uploadedFiles.length === 3 ? true : false}
                      onChange={handleFileChange} 
                      ref={fileInputRef}
                    />

                  {uploadedFiles.length < 3 &&

                    <div className='iconn'>
                      <img className='upload-img' alt='Upload icon' src={require('../../assets/images/upload.png')} />
                    </div>

                  }

                    {uploadedFiles.length === 0 &&  <p>3 More Files to upload</p>}

                    {uploadedFiles.length === 1 &&  <p>2 More Files to upload</p>}

                    {uploadedFiles.length === 2 &&  <p>1 More File to upload</p>}

                    {uploadedFiles.length === 3 && <p>Maximum files Uploaded</p>}

                  </div>
                  { showProgress && (

                    <section className='loading-area'>
                      { files.map((file, index) => (

                        <li className='roww' key={index}>
                          <i className='icon-file'></i>
                          <div className='content'>
                            <div className='details'>
                              <div className='name'>
                                {`${file.name}  uploading`}
                              </div>
                              <div className='percent'>
                                {`${file.loading}%`}
                              </div>
                              <div className='loading-bar'>
                                <div className='loading' style={{width: `${file.loading}%`,}}>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </section>
                  )}
                  
                  <section className='uploaded-area'>
                    {uploadedFiles.map((file, index) => (
                      <li className='roww' key={index}>
                        <div className='content-upload'>
                          <i className='icon-file'></i>
                          <div className='details'>
                            <span className='name'>{file.name}</span>
                            <span className='size'>{file.size}</span>
                          </div>
                        </div>
                        <div>
                          <i className='icon-check'></i>
                          <i className='icon-delete ml-2' onClick={() => removeUploadedFile(index)}></i>
                        </div>
                        
                      </li>
                    ))} 
                  </section>

                </div>


                <div>

                  {/* <Dropzone
                    getUploadParams={getUploadParams}
                    onChangeStatus={handleChangeStatus}
                    // accept=".pdf, .jpg, .png, .doc, .docx"
                    maxFiles={3}
                    maxSizeBytes={10000000}
                    multiple={true}
                    canRemove={true}
                    canCancel={true}
                    inputWithFilesContent={files => `${3 - files.length} more`}
                    submitButtonDisabled={files => files.length < 3}
                    validate={fileValidator}
                    
                  /> */}

                    {/* <div className="progress-bar">
                      <div
                        className="progress-bar-inner"
                        style={{ width: selectedFile ? `${uploadProgress}%` : `${0}%` }}
                      ></div>
                    </div> */}

                </div>
  
              </div>
                
            </div>

            <div className="row">
                
                <div className="col">
                    <label className="haveInfo">Email<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>
                    <small>
                      SHIPCONREP requires email verification to accept your concern. The email address you provide does
                      not have to necessarily be your name identifier. A verification code will be sent to your email, valid for
                      15 minutes. Your employer will not receive the email address from SHIPCONREP.
                    </small>
                <input 
                    type="email" 
                    {...register('email')} 
                    defaultValue={formData?.email}
                    className="form-control"
                    name='email'
                    maxLength={200}
                />

                {

                    errors?.email &&

                        <div className='err'>
                            {errors?.email?.message}
                        </div>

                }
                
                </div>

                {/* <div className="reporting-checkbox-wror position-relative mt-3 ">
                  <MailCopyCheckbox />
              </div> */}
                
            </div>
            
            <div className="row">

              <div className='col-md-6'>

                <div className="d-grid gap-2 mt-4 mb-4">

                    <button className="btn btn-primary btn-informant" 
                        
                        onClick={() => {
                            setNavTab(navTab - 1)
                            setCurrent(current - 1)
                        }}
                    >Back<i className="icon-arrow-left1"></i></button>

                </div>

              </div>

              <div className='col-md-6'>

                <div className="d-grid gap-2 mt-4 mb-4">
                  <button className="btn btn-success btn-informant btn-informant-submit" disabled={isButtonDisabled}  type="submit">Submit <i className="icon-check"></i></button>
                </div>

              </div>

            </div>

            {/* {JSON.stringify(formData)} */}

          </form>

        </div>

      </Spin>

    </div>

  )

}

export default Step5